import { IconDefinition } from "./types";

const fileCirclePlus: IconDefinition = {
  iconName: "file-circle-plus",
  width: 576,
  height: 512,
  svgPathData:
    "M80 48l128 0 0 160 208 0 0-48-160-160-224 0 0 512 244 0c-10.5-14.6-19-30.7-25.1-48L80 464 80 48zM256 67.9l92.1 92.1-92.1 0 0-92.1zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 64 0 0 32-64 0 0 64-32 0 0-64-64 0 0-32 64 0 0-64 32 0 0 16z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "file-circle-plus",
  unicode: 0xe494,
};

export { fileCirclePlus };
